// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__T5zR5","value":"styles_value__4Bgws"};